export default __webpack_public_path__ + "static/media/no-image.e4ce1cb8.png";